import * as TYPES from '../types';

export const getAllBannerAction = () => {
    return {
        type: TYPES.GET_ALL_BANNERS,
    };
};

export const getAllBannerSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_BANNERS_SUCCESS,
        payload: payload
    };
};
